module.exports = __webpack_public_path__ + "img/大风车.d2cb869d.png";